import { observer } from 'mobx-react-lite'
import type ConsultationSchedulerViewModel from '@/features/jobs/details/consultation/ConsultationSchedulerViewModel'
import { format } from 'date-fns'
import { AvailableDaysList, AvailableDay } from './'

interface AvailableDaysListContainerProps {
  vm: ConsultationSchedulerViewModel
  top?: number
  testId?: string
}

export const AvailableDaysListContainer = observer(
  function AvailableDaysListContainer({
    vm,
    top,
    testId,
  }: AvailableDaysListContainerProps) {
    return (
      <AvailableDaysList
        selectedKey={vm.dayIndex}
        onChange={(selection) => {
          vm.setDay((selection as Set<number>).values().next().value ?? 0)
        }}
        top={top}
        testId={testId}
      >
        {vm.scheduledDays.map((d, index) => (
          <AvailableDay
            key={index}
            id={index}
            day={format(d.day, 'd')}
            month={format(d.day, 'EEE')}
            hasTimesSelected={d.selectedTimeSlots.length > 0}
            testId={testId ? `${testId}-day-${index}` : undefined}
          />
        ))}
      </AvailableDaysList>
    )
  },
)
